<template>
  <section hidden>
    <video ref="video" autoplay></video>
    <canvas
      ref="canvas"
      :width="canvasObj.WIDTH"
      :height="canvasObj.HEIGHT"
    ></canvas>
    <img ref="image" />
  </section>
</template>

<script lang="ts">
import { AttentionRest } from "@/services/rest/attention.rest";
import { getUserFromStorage } from "@/utils/user-store.util";
import { EditUserService } from "@/views/EditUser/edit-user.service";
import { defineComponent } from "vue";
import { AttentionService } from "./attention.service";

export default defineComponent({
  name: "Attention",
  computed: {
    service(): AttentionService {
      return new AttentionService();
    },
    userService(): EditUserService {
      return new EditUserService();
    },
    attentionRest(): AttentionRest {
      return new AttentionRest();
    },
  },
  data() {
    return {
      hasInterval: null as any,
      configs: getUserFromStorage()?.userConfiguration,
      canvasObj: {
        WIDTH: 640 as number,
        HEIGHT: 480 as number,
        pics: [] as HTMLImageElement[],
        error: undefined as any,
        isCaptured: undefined as any,
      },
    };
  },
  mounted() {
    this.getConfigs();
    this.mountStream();
  },
  unmounted() {
    this.stopStream();
  },
  methods: {
    mountStream(): void {
      if (this.configs?.attentionEnabled === true) {
        this.initStream();
        this.loopFrames();
      }
    },
    initStream(): void {
      this.service.startCamera(this.$refs.video as HTMLVideoElement);
    },
    stopStream(): void {
      this.service.stopCamera();
      clearInterval(this.hasInterval);
    },
    capturePics(): void {
      var interval: number;
      this.canvasObj.pics = [];
      const seconds = 2;
      const fps = 25;
      const secondsPerFrame = 1 / fps;
      const frameCount = seconds * fps;
      const img = this.$refs.image as HTMLImageElement;
      const video = this.$refs.video as CanvasImageSource;
      const canvas = this.$refs.canvas as HTMLCanvasElement;
      const ctx = canvas?.getContext("2d");

      interval = setInterval(() => {
        if (this.canvasObj?.pics?.length < frameCount) {
          ctx?.drawImage(
            video,
            0,
            0,
            this.canvasObj.WIDTH,
            this.canvasObj.HEIGHT
          );

          if (img && img.src !== null) {
            img.src = canvas?.toDataURL("image/jpeg");
            this.canvasObj.pics.push(img);
          }
        } else {
          this.sendDetections(interval, fps);
        }
      }, secondsPerFrame * 1000);
    },
    sendDetections(interval: any, fps: any): void {
      if (this.configs?.attentionEnabled === true) {
        clearInterval(interval);
        this.service.startDetection(this.canvasObj.pics, fps);
        this.canvasObj.pics = [];
      }
    },
    loopFrames(): void {
      clearInterval(this.hasInterval);
      this.hasInterval = setInterval(() => {
        this.capturePics();
      }, getUserFromStorage().globalConfiguration.attentionConfig?.detectionInterval * 1000);
    },
    getConfigs(): void {
      if (
        getUserFromStorage().globalConfiguration &&
        getUserFromStorage().globalConfiguration.attentionConfig
          .attentionEnabled
      ) {
        this.configs = getUserFromStorage()?.userConfiguration;
      } else {
        this.configs.attentionEnabled = false;
      }
    },
  },
});
</script>
